module.exports = "https://portperrypedals.ca/_res/img/lhf_light.a81089a.png";